<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Sigout list
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Created_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                <b-button inline class="m-1" variant="warning" @click="so.opt['created_at_ed'] = ''; so.opt['created_at_sd'] = ''; refresh()">Clear</b-button>
              </b-form>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Refund_at
                <b-button size="sm" variant="info" @click="set_sd('', 'refund_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'refund_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'refund_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'refund_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'refund_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'refund_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.refund_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.refund_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="opt_description">Description</label>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="ph_search_group">Group Name</label>
            <b-button size="sm" id="ph_search_group" :variant="group_name ? 'primary' : 'success'" @click="chainGroup = true">Select Group</b-button>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_partner">Partner Name</label>
            <b-button size="sm" id="ph_search_partner" :variant="partner_name ? 'primary' : 'success'" @click="chainPartner = true">Select Partner</b-button>
            <b-button size="sm" id="ph_clear_partner" variant="warning" @click="clearChain('partner')">Clear</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="3">
            <label for="ph_search_opt_type">Complate</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_del']" @change="refresh" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_opt_type">Recovery</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_recovery']" @change="refresh" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_opt_type">Approve</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_approve']" @change="refresh" />
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2">
          <b-badge variant="primary">
            TOTAL : {{(model.enable + model.disable) || 0}}
          </b-badge>
          <br>
          <b-badge variant="success">
            Waiting : {{model.disable || 0}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Complate : {{model.enable || 0}}
          </b-badge>
        </b-col>
        <b-col sm="10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='description';so.skt='Description'">Descriptoin</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="partner" slot-scope="row">
          {{row.item.partner.username || '-'}}
        </template>
        <template slot="group" slot-scope="row">
          {{row.item.group.groupname || '-'}}
        </template>
        <template slot="is_recovery" slot-scope="row">
          <c-switch color="primary" :disabled="true" label size="sm" v-model="row.item.is_recovery" />
        </template>
        <template slot="is_approve" slot-scope="row">
          <c-switch color="warning" :disabled="true" label size="sm" v-model="row.item.is_approve" />
        </template>
        <template slot="is_del" slot-scope="row">
          <b-badge variant="primary" v-if="row.item.is_del"> Complate </b-badge>
          <b-badge variant="danger" v-else> Waiting </b-badge>
        </template>

        <template slot="level" slot-scope="row">{{row.item.level | level}}</template>
        <template slot="group.name" slot-scope="row">{{row.item.group && row.item.group.name}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate }}</template>
        <template slot="signup_addr" slot-scope="row">{{row.item.signup_addr }}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Detail</b-btn>
        </template>
      </b-table>

      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Find then Partner and Select" size="xl"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import { Api } from '@/service';
import custom from '@/custom';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import partnerList from '../../Management/partner/Partner.List'
import groupList from '../../Management/group/Group.List'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, vSelect, cSwitch, partnerList, groupList, },
  data: () => ({
    auto_refresh : false,
    model : { total : 0, enable : 0, disable : 0 },
    datepicker,
    loading : false,
    group_name : '',
    chainGroup : false,
    partner_name : '',
    chainPartner : false,
    so : default_opt(),
    custom,
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', label: 'No.' },
        { key: 'is_del', sortable: true, label:  'Status'},
        { key: 'partner', label: 'Partner' },
        { key: 'group', label: 'Company Name' },
        { key: 'is_recovery', sortable: true, label:  'Recovery (Continue)'},
        { key: 'is_approve', sortable: true, label:  'Approve (End)' },
        { key: 'created_at', label: 'Requested_at', sortable: true },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 15%'  },
    ]}
  },
  methods: {
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'partner':
          delete this.so.opt.partner_id
          this.partner_name = '';
          this.chainPartner = false;
          break;
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    change_recovery($event) { if($event == true || $event == false) { this.so.opt['is_recovery'] = $event; this.refresh(); } },
    change_done($event) { if($event == true || $event == false) { this.so.opt['is_del'] = $event; this.refresh(); } },
    change_approve($event) { if($event == true || $event == false) { this.so.opt['is_approve'] = $event; this.refresh(); } },
    setPartner(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        // this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if((k.length > 3 && k.substring(k.length - 3) == "_id") || [].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    async remove(n) {
      try {
        let rs = await Api.Manager_Call('user.signout', 'delete', {id : n.id});
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name);
        } else {
          this.$toastr.s('delete', "failed");
        }
        this.list(); this.refresh();

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { if(!this.loading) { this.$refs._list.refresh(); } },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      this.loading = true
      let so = {
        target : 'user.signout', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage,
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }) }


      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" } }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { cond = { name : k[i].slice(0, 10), value : '', op : "is null" } }
              else { cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" } }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }

      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.loading = false; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    accept(user){
      user.is_verified = true;
      Api.Manager_Call('user.signout','update.accept', user)
        .then(() => { this.$emit('refresh'); this.$toastr.s('Approval'); this.refresh();}).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      Api.Manager({ target : 'user.signout', cmd : 'summary', body : { ts : new Date().getTime() } })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) { this.$router.push(`signout/${item.id}`); },
  },
  created() { console.log('signout_List.vue', 'created'); },
  destroyed() { console.log('signout_List.vue', 'destroyed'); },
  mounted() {
    console.log('signout_List.vue', 'mounted');
    this.summary();
  },
}
</script>
